import { createTheme } from '@mantine/core';

export const theme = createTheme({
  fontFamily: 'Inria Serif, serif',
  fontFamilyMonospace: 'Monaco, Courier, monospace',
  headings: {
    fontFamily: 'Inria Serif, serif',
    fontWeight: '700',
  },
  defaultRadius: 'md',
  primaryColor: 'orange',
  colors: {
    // Add custom colors used throughout the app
    brand: [
      '#e6f7ff', // 0: Menu background
      '#228be6', // 1: Bottom navigation
      '#ff6b00', // 2: Cart button active
      '#f8f9fa', // 3: Cart button inactive
      '#868e96', // 4: Text dimmed
      '#e6f7ff', // 5: Duplicate for required array length
      '#228be6', // 6: Duplicate for required array length
      '#ff6b00', // 7: Duplicate for required array length
      '#f8f9fa', // 8: Duplicate for required array length
      '#868e96', // 9: Duplicate for required array length
    ],
  },
  components: {
    Text: {
      defaultProps: {
        size: 'md',
      },
    },
    Title: {
      defaultProps: {
        size: 'h1',
      },
    },
    Paper: {
      defaultProps: {
        withBorder: true,
        shadow: 'sm',
      },
      styles: {
        root: {
          // Mantine v7 uses camelCase for data attributes in style selectors
          '&[dataInteractive]': {
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            '&:hover': {
              transform: 'translateY(-1px)',
              // Shadow removed - components should handle conditional shadows for dark mode
              // See MenuItem.tsx for example of dark mode shadow implementation
            },
          },
        },
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
    ActionIcon: {
      defaultProps: {
        radius: 'md',
      },
    },
  },
  other: {
    // Common layout values
    layout: {
      headerHeight: 60,
      bottomNavHeight: 60,
      messengerBarHeight: 60, // Height of the input bar at the bottom
      cartBarHeight: 48, // Height of the floating cart button
      scrollOffset: 100, // Offset for scroll-to-element calculations (accounts for sticky headers)
      qrCodeSize: 200, // Maximum width for QR code display (in pixels)
      heroImageAspectRatio: '16 / 9', // Target display ratio for menu hero image
      heroImageMaxHeight: 260, // Maximum height for menu hero image (in pixels)
      categoryTopImageAspectRatio: '16 / 9', // Target display ratio for category modal top image
      categoryTopImageMaxHeight: 220, // Maximum height for category modal top image (in pixels)
      onboardingImageAspectRatio: '4 / 3', // Target display ratio for onboarding modal image
      onboardingImageMaxHeight: 240, // Maximum height for onboarding modal image (in pixels)
      bottomSpacerHeight: 220, // Height of bottom spacer to ensure content visibility above fixed elements
      autocompleteMaxHeight: 200, // Maximum dropdown height for autocomplete search
      menuItemImageSize: 60, // Size for menu item thumbnail images (in pixels)
      modalImageSize: 200, // Size for menu item modal images (in pixels)
      zIndex: {
        bottomNav: 6,
        messengerBar: 7, // Deprecated: use menuChatBar instead
        menuChatBar: 7, // Main chat bar z-index
        cartBar: 6, // Same as bottomNav, but will be above chat area
        chatArea: 6, // Chat area z-index
        notifications: 10,
      },
    },
    // Common animations
    animations: {
      transition: 'all 0.2s ease',
      hover: {
        transform: 'translateY(-1px)',
        // Shadow removed - components should handle conditional shadows for dark mode
        // boxShadow should be applied conditionally based on color scheme in components
      },
    },
    // Common shadows (light mode only - components should use conditional shadows)
    // These are reference values for light mode; dark mode should use white glow shadows
    shadows: {
      card: '0 2px 4px rgba(0,0,0,0.1)', // Light mode only
      nav: '0 -2px 10px rgba(0, 0, 0, 0.1)', // Light mode only
      // Dark mode shadows should use white glow: rgba(255, 255, 255, 0.15) with dark shadow
    },
    // Language badge colors for restaurant header
    languageBadge: {
      warning: {
        background: '#fff3cd', // Warning background (yellow) for source language
        border: '#ffeaa7', // Warning border
      },
      info: {
        background: '#d1f2eb', // Info background (green) for English translation
        border: '#a3e4d7', // Info border
      },
    },
  },
}); 